<span >
    <i class="fa fa-ellipsis-v" style="cursor: pointer;width: 20px;
    background: #0098a6;
    text-align: center;
    height: 20px;
    border-radius: 50%;
    padding-top: 5px;
    color: white;" 
      title="Actions" (clickOutside)="stopediting()"></i>
  </span>